import React from 'react';
import { Tooltip } from '@mui/material';
import { sentenceCase } from '../../utils/strings';
import Selector from '../util/Selector';

import './status.css';

const TEXTS = {
  saved: 'Your request is not yet submitted',
  submitted: 'Waiting for review by an Onboard team member',
  'being reviewed': 'We are reviewing your request',
  shipped: 'Your requested device has been shipped',
  'being processed': 'Your building data is being processed by the Onboard team',
  finished: 'Your request has been deployed',
};

const Status = ({ text }) => (
  <Tooltip title={TEXTS[text]}>
    <span className={`status-text ${text.replace(' ', '-')}`}>{sentenceCase(text)}</span>
  </Tooltip>
);

export const StatusSelector = ({ status, onValueChange }) => (
  <Selector
    options={Object.entries(TEXTS).map(([key, description]) => ({
      key,
      id: key,
      display: `${key} - ${description}`,
    }))}
    selected={status}
    onChange={(e) => onValueChange(e.target.value)}
  />
);

export default Status;
